import { createReducer, on } from '@ngrx/store';
import { RoomRowClicked, DailyServicePriceClicked, ReplaceRoomRowClicked, isChangedData } from "./action";
import { HotelDailyServiceInfo, HotelRoomInfo } from '@donstudio/shared/api/models';
import { IsChangedModel } from './model';

export const initialStateRoom: HotelRoomInfo = {};
export const initialReplaceStateRoom: HotelRoomInfo = {};
export const initialDailyServicePrice: HotelDailyServiceInfo[] = [];
export const initialIsChangedData: IsChangedModel = { isChanged: false };

export const roomReducer = createReducer(
    initialStateRoom,
    on(RoomRowClicked, (state, { roomData }) => ({
        dailyDetail: roomData?.dailyDetail,
        roomIndex: roomData?.roomIndex,
        roomName: roomData?.roomName,
    }))
);

export const dailyServicePriceReducer = createReducer(
    initialDailyServicePrice,
    on(DailyServicePriceClicked, (state, { daily }) => ({
        ...state,
        daily,
    }))
);

export const replaceRoomReducer = createReducer(
    initialStateRoom,
    on(ReplaceRoomRowClicked, (state, { replaceRoomData }) => ({
        dailyDetail: replaceRoomData?.dailyDetail,
        roomIndex: replaceRoomData?.roomIndex,
        roomName: replaceRoomData?.roomName,
    }))
);

export const isChangedDataReducer = createReducer(
    initialIsChangedData,
    on(isChangedData, (state, { newValue }) => ({ ...state, myBooleanValue: newValue }))
);